<template>
  <rest-list
    :max-height="tableHeight"
    :payload="fetchEndpoint"
    @dataLoaded="setData($event)"
  >
    <template v-if="data[0]">
      <rest-list-column
        prop="domain"
        :title="$t('CampaignChannelAnalytics_Table_Domains')"
        :width="250"
        :fixed="true"
      />
      <template v-for="(metricGroup, metricIndex) in data[0].metricGroups">
        <rest-metric-column
          v-for="(metric, index) in metricGroup.metrics"
          :prop="'metricGroups[' + metricIndex + ']'"
          :key="index"
          :index="index"
          :metric-group="metricGroup"
          :metric="metric"
        />
      </template>
    </template>
  </rest-list>
</template>

<script>
import RestList from '@/common/components/rest/RestList'
import RestListColumn from '@/common/components/rest/RestListColumn'
import RestMetricColumn from '@/common/components/rest/RestMetricColumn'
import { projectEndpoint } from '@/core/helpers'
import { EventBus } from '@/core/EventBus'
import moment from 'moment'

export default {
  name: 'Domains',

  components: { RestListColumn, RestMetricColumn, RestList },

  data() {
    return {
      data: [],
      date_from: this.$route.query.date_from || '',
      date_to: this.$route.query.date_to || ''
    }
  },

  mounted() {
    EventBus.$on('common/components/dashboard/DateFilter:onChange', event => {
      this.date_from = moment(event.start).format('YYYY-MM-DD')
      this.date_to = moment(event.end).format('YYYY-MM-DD')
    })
  },

  computed: {
    campaignId() {
      return this.$route.query.id || null
    },
    tableHeight() {
      return $('.page').height() - 200
    },
    fetchEndpoint() {
      return projectEndpoint({
        method: 'get',
        url: `campaigns/${this.campaignId}/analytics/email/domains`,
        params: {
          date_from: this.date_from,
          date_to: this.date_to
        }
      })
    }
  },

  methods: {
    setData(event) {
      this.data = event
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/modules/analytics/components/Domains.vue